/**
 * Create and return an object of parameters present in a url
 *
 * @param {string} url - A url with or without query params
 * @return {Object} - an object with all params query present in url
 *
 * example url: marketplace.com/search?cgid=smart-termostats
 * example return: { cgid: 'smart-thermostats' }
*/
const getParameters = function getParameters(url) {
  const params = {};
  const paramArray = url.match(/(\w|%|\s|-)+=(\w|%|\s|-)+/gm);

  if (!paramArray) {
    return params;
  }

  paramArray.forEach((param) => {
    const [name, value] = param.split('=');

    if (!name || !value) {
      return;
    }

    const decodedName = decodeURIComponent(name);
    const decodedValue = decodeURIComponent(value);

    if (!params[decodedName]) {
      params[decodedName] = [];
    }

    params[decodedName].push(decodedValue);
  });

  return params;
};

/**
 * Adds query parameters to given url
 *
 * @param {string} url - A url with or without query params
 * @param {Object} params - key value pairs of parameters to add
 * @return {Object} - url with query params appended
 *
 * example url: marketplace.com/search
 * exmaple params: { color: 'Black' }
 * example return: marketplace.com/search?color=Black
*/
const addParameters = function addParameters(url, params) {
  let appendedChars = url.match(/\?.*$/) ? '&' : '?';

  appendedChars += Object.keys(params).map(pname => `${pname}=${params[pname]}`).join('&');

  return `${url}${appendedChars}`;
};

/**
 * Removes query parameters from given url
 *
 * @param {string} url - A url with query params
 * @param {Array} params - Parameters to be removed
 * @return {string} - url with query params removed
 *
 * example url: marketplace.com/?firstParam=true&secondParam=false
 * exmaple params: ['secondParam']
 * example return: marketplace.com/?firstParam=true
*/
const removeParameters = function removeParameters(url, params) {
  const baseUrl = url.split('?').shift();
  const paramArray = url.match(/(\w|%|\s|-)+=(\w|%|\s|-)+/gm);
  const filteredArray = paramArray.filter(param => !params.includes(param.split('=').shift()));

  if (filteredArray.length > 0) {
    const filteredParams = filteredArray.join('&');

    return `${baseUrl}?${filteredParams}`;
  }
  return baseUrl;
};

export {
  getParameters,
  addParameters,
  removeParameters,
};
